"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductDataIndexes = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
/**
 * Get indexes of `Products` container component children that are of type `ProductData`
 * @returns array of index-numbers for compoents of type `ProductData`
 * @param schemaComponents
 */
var getProductDataIndexes = function (schemaComponents) {
    return schemaComponents.reduce(function (indexes, component, currentIndex) {
        if (component.type === seesignage_utils_1.ComponentType.productData) {
            indexes.push(currentIndex);
        }
        return indexes;
    }, []);
};
exports.getProductDataIndexes = getProductDataIndexes;
//# sourceMappingURL=products.js.map